/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Compare_Blocked_ProtocolInputs */

const en_us2_body_assessment_compare_blocked_protocol = /** @type {(inputs: Body_Assessment_Compare_Blocked_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One of these assessments fell outside the photo protocol, so the difference between the two is not shown. Both results are still here, side by side.`)
};

const pt_br2_body_assessment_compare_blocked_protocol = /** @type {(inputs: Body_Assessment_Compare_Blocked_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma destas avaliações ficou fora do protocolo das fotos, então a diferença entre as duas não é mostrada. Os dois resultados continuam aqui, lado a lado.`)
};

const es_419_body_assessment_compare_blocked_protocol = /** @type {(inputs: Body_Assessment_Compare_Blocked_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una de estas evaluaciones quedó fuera del protocolo de fotos, así que no se muestra la diferencia entre las dos. Los dos resultados siguen aquí, lado a lado.`)
};

const pt_pt2_body_assessment_compare_blocked_protocol = /** @type {(inputs: Body_Assessment_Compare_Blocked_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma destas avaliações ficou fora do protocolo das fotos, por isso a diferença entre as duas não é mostrada. Os dois resultados continuam aqui, lado a lado.`)
};

const fr_fr2_body_assessment_compare_blocked_protocol = /** @type {(inputs: Body_Assessment_Compare_Blocked_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'une de ces évaluations est sortie du protocole photo, donc l'écart entre les deux n'est pas affiché. Les deux résultats restent ici, côte à côte.`)
};

const de_de2_body_assessment_compare_blocked_protocol = /** @type {(inputs: Body_Assessment_Compare_Blocked_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine dieser Messungen lag außerhalb des Fotoprotokolls, daher wird der Unterschied nicht angezeigt. Beide Ergebnisse stehen weiter hier, nebeneinander.`)
};

const it_it2_body_assessment_compare_blocked_protocol = /** @type {(inputs: Body_Assessment_Compare_Blocked_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una di queste valutazioni è uscita dal protocollo delle foto, quindi la differenza tra le due non viene mostrata. Entrambi i risultati restano qui, uno accanto all'altro.`)
};

/**
* | output |
* | --- |
* | "One of these assessments fell outside the photo protocol, so the difference between the two is not shown. Both results are still here, side by side." |
*
* @param {Body_Assessment_Compare_Blocked_ProtocolInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_compare_blocked_protocol = /** @type {((inputs?: Body_Assessment_Compare_Blocked_ProtocolInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Compare_Blocked_ProtocolInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_compare_blocked_protocol(inputs)
	if (locale === "es-419") return es_419_body_assessment_compare_blocked_protocol(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_compare_blocked_protocol(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_compare_blocked_protocol(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_compare_blocked_protocol(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_compare_blocked_protocol(inputs)
	return en_us2_body_assessment_compare_blocked_protocol(inputs)
});
export { body_assessment_compare_blocked_protocol as "body-assessment.compare_blocked_protocol" }